<template>
    <div id="reset-password" class="container">
        <div class="columns is-mobile">
            <div class="column is-10-mobile is-offset-1-mobile is-4-tablet is-offset-4-desktop">
                <div class="columns wrapper">
                    <div class="column is-12">
                        <div id="logo">
                            <img src="/images/dashboard/pasti-logo-big.svg">
                        </div>
                        <div class="title is-5 has-text-centered">
                            Enter New Password
                        </div>

                        <!-- Forgot password form -->
                        <form id="reset-password-form" data-vv-scope="reset-password-form"  v-on:submit.prevent>
                            <!-- Backend success and error message -->
                             <div class="columns">
                                <div class="column is-10 is-offset-1-tablet has-text-link">
                                    You are currently resetting the password for {{ query_param_email }}
                                </div>

                             </div>
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <!-- Display success message -->
                                    <div class="notification is-success" v-if="success_message">
                                        <button class="delete" @click="success_message = ''"></button>
                                        <p>{{ success_message }}</p>
                                    </div>

                                    <!-- Display error message -->
                                    <div class="notification is-danger" v-if="error_message">
                                        <button class="delete" @click="error_message = ''"></button>
                                        <p v-if="typeof error_message === 'string'">{{ error_message }}</p>
                                        <div class="content" v-else>
                                            <ul>
                                                <li v-for="(error, index) in error_message">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Password text input -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <div class="field">
                                        <p class="control has-icons-right">
                                            <input v-model="password" v-validate="{ rules: { required: true, min: 8} }"
                                                   class="input" type="password" name="password" placeholder="New Password" ref="password">

                                            <span v-show="errors.has('reset-password-form.password')" class="icon is-small is-right">
                                                  <i class="fa fa-warning"></i>
                                                </span>

                                            <span class="help is-danger" v-show="errors.has('reset-password-form.password')">
                                                {{ errors.first('reset-password-form.password') }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Password confirmation text input -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <div class="field">
                                        <p class="control has-icons-right">
                                            <input v-model="password_confirmation" v-validate="'required|confirmed:password'"
                                                   class="input" type="password" name="password_confirmation" data-vv-as="password"
                                                   placeholder="New Password Confirmation">

                                            <span v-show="errors.has('reset-password-form.password_confirmation')" class="icon is-small is-right">
                                                  <i class="fa fa-warning"></i>
                                                </span>

                                            <span class="help is-danger" v-show="errors.has('reset-password-form.password_confirmation')">
                                                {{ errors.first('reset-password-form.password_confirmation') }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Submit button -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet has-text-centered">
                                    <button type="button" class="button submit-button" @click="validateResetPasswordForm('reset-password-form')">
                                        Submit
                                    </button>
                                </div>

                            </div>
                            <div class="columns" v-if="startCountTimer">
                                <div class="column is-12 has-text-centered has-text-grey">
                                    Redirecting to Login Page in  <b>{{ timerRedirectLogin }}</b> second ...
                                </div>
                            </div>
                        </form>

                        <!-- Already have account link -->
                        <div class="columns">
                            <div class="column is-10 is-offset-1-tablet has-text-centered">
                                <div class="forgot-password title is-6">
                                    <a :href="login_url">Already have account?</a>
                                </div>
                            </div>
                        </div>

                        <!-- Google Play Badge -->
                        <div class="columns is-mobile download-app">
                            <div class="column is-6 is-offset-3">
                                <div class="columns is-mobile">
                                    <div class="column is-4">
                                        <p>Download our app</p>
                                    </div>
                                    <div class="column is-8">
                                        <img src="/images/dashboard/google-play-badge.png" class="img-responsive">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Copyright -->
                        <div class="columns">
                            <div class="column is-12">
                                <div class="copyright has-text-centered">
                                    Copyright © {{ current_year }} MyEG Servics Berhad. All Rights Reserved. Version 1.1
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const moment = require('moment');

    export default {
        props: {
            login_url: {
                type: String,
                required: true
            },
            reset_password_url: {
                type: String,
                required: true
            },
        },
        data: function() {
            return {
                password: '',
                password_confirmation: '',
                success_message: '',
                error_message: '',
                timerRedirectLogin: 5,
                startCountTimer: false,
                query_param_email: ''
            }
        },
        watch: {
            success_message() {
                this.setClearTimeout('success')
            },
            error_message() {
                this.setClearTimeout('error')
            },
        },
        methods: {
            validateResetPasswordForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    console.log(result);
                    if (result) {
                        this.resetPassword();
                    }
                });
            },
            resetPassword: function()
            {
                let postData = {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    email: this.email,
                    reset_token: this.reset_token

                };

                axios.post(this.reset_password_url, postData)
                    .then(response => {
                        let vm = this;

                        if (response.data.message !== undefined) {
                            vm.success_message = response.data.message;

                            this.startCountTimer = true;
                            this.startCountdownRedirectToLoginPage();
                        }

                        if (response.data.error !== undefined) {
                            vm.error_message = response.data.error;
                        }
                    })
                    .then(() => {
                        this.errors.clear();
                    })
                    .catch(error => {
                        if (error.response !== undefined) {
                            // Display validation error messages.
                            if (error.response.status === 422) {
                                let errorMessage = [];

                                error.response.data.errors.foreach(function (item, key) {
                                    errorMessage.push(item[0]);
                                });

                                this.error_message = errorMessage;
                            }

                            if ( error.response.status === 410 || 
                                error.response.status === 400 ||
                                error.response.status === 500
                            ) {
                                this.error_message = error.response.data.message;
                            }
                        }
                    })
            },
            setClearTimeout(message) {
                if (message == 'error') {
                        setTimeout(() => {
                        this.error_message = '';
                    }, 5000);
                } else {
                    setTimeout(() => {
                        this.success_message = '';
                    }, 5000);
                }

            },
            startCountdownRedirectToLoginPage() {
                const countdownInterval = setInterval(() => {
                    if (this.timerRedirectLogin > 1) {
                        this.timerRedirectLogin--;
                    } else {
                        clearInterval(countdownInterval);
                        this.timerRedirectLogin = 0;
                        window.location.href = '/auth/login'
                    }
                }, 1000);
            }
        },
        computed: {
            moment: function() {
                return moment;
            },
            current_year: function() {
                return moment().utcOffset('+0800').year();
            },
            email: function() {
                let match = RegExp('[?&]email=([^&]*)').exec(window.location.search);

                let email = match && decodeURIComponent(match[1].replace(/\+/g, ' '));

                if (email === null) {
                    return ''
                }

                return email;
            },
            reset_token: function() {
                let pathArray = window.location.pathname.split( '/' );

                if (pathArray.length < 4) {
                    return '';
                }

                return pathArray[3];
            }
        },
        created() {
            // Get the query string part of the URL
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const emailParam = urlParams.get('email');
            
            this.query_param_email = emailParam ? emailParam.replace(/ /g, '+') : ''; // Replacing space back to '+'
        }
    }
</script>